import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchWallets, fetchUserWalletTransactions, createWalletTransaction } from "../../redux/Slices/WalletSlice";
import { toast } from "react-toastify";
import { FaWallet, FaEye, FaPlus } from "react-icons/fa";
import { useTitle } from "../../context/TitleContext";

import Pagination from '../../components/Pagination';
const Wallets = () => {
  const dispatch = useDispatch();
  const { setTitle } = useTitle();
  const { wallets, walletMeta, loading, transactions } = useSelector((state) => state.wallets);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showTransactionsModal, setShowTransactionsModal] = useState(false);
  const [showAddTransactionModal, setShowAddTransactionModal] = useState(false);
  const [selectedWallet, setSelectedWallet] = useState(null);
  
  // Transaction Form State
  const [transType, setTransType] = useState("credit");
  const [transAmount, setTransAmount] = useState("");
  const [transNotes, setTransNotes] = useState("");

  useEffect(() => {
    setTitle("المحافظ الإلكترونية");
  }, [setTitle]);

  useEffect(() => {
    dispatch(fetchWallets({ page: currentPage, search }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    dispatch(fetchWallets({ page: 1, search }));
  };

  const handleViewTransactions = (wallet) => {
    setSelectedWallet(wallet);
    dispatch(fetchUserWalletTransactions({ userId: wallet.user_id, page: 1 }));
    setShowTransactionsModal(true);
  };

  const handleAddTransaction = (wallet) => {
    setSelectedWallet(wallet);
    setTransType("credit");
    setTransAmount("");
    setTransNotes("");
    setShowAddTransactionModal(true);
  };

  const submitTransaction = () => {
    const amountVal = parseFloat(transAmount);
    if (isNaN(amountVal) || amountVal <= 0) {
      toast.error("الرجاء إدخال مبلغ صحيح أكبر من الصفر");
      return;
    }
    if (transAmount.toString().includes('.') && transAmount.toString().split('.')[1].length > 2) {
      toast.error("الحد الأقصى للكسور هو رقمين بعد الفاصلة");
      return;
    }
    dispatch(createWalletTransaction({
      userId: selectedWallet.user_id,
      type: transType,
      transaction_type: "manual_adjustment",
      amount: amountVal,
      notes: transNotes
    })).then((res) => {
      if (!res.error) {
        setShowAddTransactionModal(false);
        toast.success("تم إضافة العملية بنجاح");
        dispatch(fetchWallets({ page: currentPage, search }));
      } else {
        toast.error(res.payload || "حدث خطأ أثناء إضافة العملية");
      }
    });
  };


  // BUG-19 fix: تعتيم وعزل الخلفية عند فتح النوافذ المنبثقة
  const overlay = { position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", backdropFilter: "blur(3px)", WebkitBackdropFilter: "blur(3px)", zIndex: 1040, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  // BUG-17 fix: تصفية المحافظ فعلياً حسب كلمة البحث (اسم/هاتف العميل) على الفرونت
  // BUG-42 fix: منع ظهور أي محفظة مجهولة (Anonymous Wallet) غير مرتبطة بمستخدم
  const filteredWallets = wallets
    ? wallets
        .filter((w) => (w.owner_type === "user" || w.admin_id === null) && w.user_id && w.user_name && w.user_phone)
        .filter((w) => {
          const q = search.trim().toLowerCase();
          if (!q) return true;
          return (
            String(w.user_phone || "").toLowerCase().includes(q) ||
            String(w.user_name || "").toLowerCase().includes(q) ||
            String(w.name || "").toLowerCase().includes(q)
          );
        })
    : [];

  return (
    <div style={{ padding: "4px 0", direction: "rtl" }}>
      <style>{`
        .wallet-table {
          width: 100%;
          border-collapse: collapse;
          text-align: right;
        }
        .wallet-table th {
          background-color: #f8fafc !important;
          color: #475569 !important;
          font-weight: 700 !important;
          font-size: 13px !important;
          padding: 14px 16px !important;
          border-bottom: 1px solid #e2e8f0 !important;
          text-align: center !important;
        }
        .wallet-table td {
          padding: 14px 16px !important;
          font-size: 14px !important;
          vertical-align: middle !important;
          border-bottom: 1px solid #f1f5f9 !important;
          text-align: center !important;
        }
        .wallet-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .wallet-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      {/* ── Header ─────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800, color: "#0f172a", fontSize: 20, display: "flex", alignItems: "center", gap: 8 }}>
            💳 المحافظ الإلكترونية للعملاء
          </h4>
          <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: 13 }}>تعديل ومراقبة وإضافة عمليات الأرصدة اليدوية لمحفظة الطالب</p>
        </div>
      </div>

      {/* ── Search Bar ───────────────────────────────── */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "18px 22px", marginBottom: 20 }}>
        <label style={{ fontSize: 13, fontWeight: 700, color: "#64748b", display: "block", marginBottom: 8, textAlign: "right" }}>البحث السريع عن عميل أو هاتف</label>
        <form className="d-flex align-items-center" onSubmit={handleSearch} style={{ maxWidth: 500, gap: 10 }}>
          <input
            style={{
              width: "100%",
              padding: "9px 14px",
              borderRadius: 9,
              border: "1.5px solid #e2e8f0",
              fontSize: 14,
              outline: "none",
              boxSizing: "border-box",
              backgroundColor: "#fff",
              transition: "border-color 0.2s, box-shadow 0.2s"
            }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="بحث برقم الهاتف أو الاسم..."
            onFocus={(e) => {
              e.target.style.borderColor = "var(--main-color)";
              e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#e2e8f0";
              e.target.style.boxShadow = "none";
            }}
          />
          <button className="btn btn-primary btn-sm" type="submit" style={{ padding: "10px 18px", borderRadius: 9 }}><i className="bi bi-search"></i></button>
          {search && (
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => {
                setSearch("");
                setCurrentPage(1);
                dispatch(fetchWallets({ page: 1, search: "" }));
              }}
              style={{ padding: "9px 16px", borderRadius: 9, minWidth: "110px" }}
            >
              مسح البحث
            </button>
          )}
        </form>
      </div>

      {/* ── Table Container ────────────────────────────── */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,.04)", padding: 0 }}>
        {loading && !showTransactionsModal && !showAddTransactionModal ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : filteredWallets.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "#94a3b8" }}>
            <FaWallet size={48} className="text-muted mb-3" />
            <p style={{ marginTop: 12, fontWeight: 600, fontSize: 15, color: "#64748b" }}>لا توجد محافظ مطابقة لبحثك</p>
          </div>
        ) : (
          <div style={{ padding: 0 }}>
            <div className="table-responsive">
              <table className="wallet-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>العميل</th>
                    <th>الهاتف</th>
                    <th>الرصيد الحالي</th>
                    <th>الحالة</th>
                    <th>تاريخ الإنشاء</th>
                    <th>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredWallets.map((wallet, index) => (
                    <tr key={wallet.id}>
                      <td>{index + 1}</td>
                      <td style={{ fontWeight: 600, color: "#0f172a" }}>{wallet.user_name}</td>
                      <td style={{ color: "#475569" }}>{wallet.user_phone}</td>
                      <td style={{ fontWeight: 700, color: "#16a34a" }}>{wallet.balance} ج.م</td>
                      <td>
                        <span style={{ fontSize: 11, fontWeight: 700, color: wallet.status ? "#15803d" : "#64748b", background: wallet.status ? "#d1fae5" : "#f1f5f9", padding: "3px 10px", borderRadius: 20 }}>
                          {wallet.status ? "نشط" : "غير نشط"}
                        </span>
                      </td>
                      <td>{new Date(wallet.created_at).toLocaleDateString('ar-EG')}</td>
                      <td>
                        <div style={{ display: "inline-flex", gap: 5, justifyContent: "center" }}>
                          <button
                            onClick={() => handleViewTransactions(wallet)}
                            title="سجل العمليات"
                            style={{ width: 30, height: 30, borderRadius: 8, border: "1px solid #bae6fd", background: "#e0f2fe", color: "#0284c7", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                          >
                            <FaEye size={12} />
                          </button>
                          <button
                            onClick={() => handleAddTransaction(wallet)}
                            title="إضافة عملية"
                            style={{ width: 30, height: 30, borderRadius: 8, border: "1px solid #d1fae5", background: "#e8fdf0", color: "var(--green-color)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                          >
                            <FaPlus size={12} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ padding: "0 16px 20px" }}>
               <Pagination meta={walletMeta} currentPage={currentPage} loading={loading} onChange={setCurrentPage} />
            </div>
          </div>
        )}
      </div>

      {/* ── Transactions Modal ─────────────────────────── */}
      {showTransactionsModal && selectedWallet && (
        <div style={overlay}>
          <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 800, boxShadow: "0 25px 60px rgba(0,0,0,.25)", overflow: "hidden" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontWeight: 800, fontSize: 17, color: "#0f172a" }}>📊 سجل عمليات محفظة: {selectedWallet.user_name}</span>
              <button onClick={() => setShowTransactionsModal(false)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#94a3b8" }}>✕</button>
            </div>
            <div style={{ padding: "20px 24px", maxHeight: "400px", overflowY: "auto" }}>
              {loading ? (
                <div className="text-center py-4"><div className="spinner-border text-primary"></div></div>
              ) : (
                <div className="table-responsive">
                  <table className="wallet-table">
                    <thead>
                      <tr>
                        <th>النوع</th>
                        <th>المبلغ</th>
                        <th>الرصيد بعد العملية</th>
                        <th>ملاحظات</th>
                        <th>التاريخ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* BUG-18 fix: ترتيب العمليات زمنياً من الأحدث للأقدم */}
                      {[...(transactions || [])]
                        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                        .map((t) => (
                        <tr key={t.id}>
                          <td>
                            <span style={{ fontSize: 11, fontWeight: 700, color: t.type === 'credit' ? "#15803d" : "var(--red-color)", background: t.type === 'credit' ? "#d1fae5" : "#fef2f2", padding: "3px 10px", borderRadius: 20 }}>
                              {t.type === 'credit' ? "إيداع" : "سحب"}
                            </span>
                          </td>
                          <td style={{ fontWeight: 600 }}>{t.amount} ج.م</td>
                          <td style={{ fontWeight: 600, color: "#475569" }}>{t.balance_after} ج.م</td>
                          <td>{t.notes || '-'}</td>
                          <td>{new Date(t.created_at).toLocaleString('ar-EG')}</td>
                        </tr>
                      ))}
                      {(!transactions || transactions.length === 0) && (
                        <tr><td colSpan="5" style={{ padding: "20px", color: "#94a3b8" }}>لا توجد عمليات مسجلة</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div style={{ padding: "14px 24px", background: "#f8fafc", display: "flex", justifyContent: "flex-end" }}>
              <button type="button" onClick={() => setShowTransactionsModal(false)} style={{ padding: "8px 20px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer" }}>إغلاق</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Add Transaction Modal ──────────────────────── */}
      {showAddTransactionModal && selectedWallet && (
        <div style={overlay}>
          <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 500, boxShadow: "0 25px 60px rgba(0,0,0,.25)", overflow: "hidden" }}>
            <div style={{ padding: "18px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontWeight: 800, fontSize: 17, color: "#0f172a" }}>💸 إضافة تعديل يدوي للرصيد: {selectedWallet.user_name}</span>
              <button onClick={() => setShowAddTransactionModal(false)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#94a3b8" }}>✕</button>
            </div>
            <div style={{ padding: "20px 24px" }}>
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>نوع العملية</label>
                <select className="wallet-custom-select" value={transType} onChange={(e) => setTransType(e.target.value)}>
                  <option value="credit">إيداع (+)</option>
                  <option value="debit">سحب (-)</option>
                </select>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>المبلغ (ج.م) *</label>
                <input
                  type="number"
                  min="0"
                  className="form-control"
                  style={inputStyle}
                  onFocus={focusHandler}
                  onBlur={blurHandler}
                  placeholder="المبلغ بالجنيه..."
                  value={transAmount}
                  onChange={(e) => setTransAmount(e.target.value.replace(/-/g, ""))}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>ملاحظات</label>
                <textarea
                  className="form-control"
                  style={inputStyle}
                  onFocus={focusHandler}
                  onBlur={blurHandler}
                  placeholder="ملاحظات توضيحية لعملية التعديل..."
                  rows="2"
                  value={transNotes}
                  onChange={(e) => setTransNotes(e.target.value)}
                />
              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #f1f5f9", paddingTop: 16 }}>
                <button type="button" onClick={() => setShowAddTransactionModal(false)} style={{ padding: "8px 20px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer" }}>إلغاء</button>
                <button type="button" onClick={submitTransaction} disabled={loading} style={{ padding: "8px 28px", borderRadius: 9, border: "none", background: "linear-gradient(135deg,var(--main-color),var(--main-light))", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
                  {loading ? 'جاري الحفظ...' : 'حفظ العملية'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Wallets;
